import { css } from "@compiled/react";

import { JiraLogo } from "@atlaskit/logo";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext } from "@/components/user-context";

import { Jfind1249SubHeading } from "../../../logged-out/jira/free/components/jfind-1249-subheading";

import { WelcomeBackHeading } from "./components";

export const LoggedInJiraFreeExistingSitesUser = () => {
    const {
        user: { name }
    } = useUserContext();

    return (
        <SignupBackgroundLayout
            ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
        >
            <h1 css={headerCss}>
                <WelcomeBackHeading name={name} />
            </h1>
            <Jfind1249SubHeading />
            <SiteActivation />
        </SignupBackgroundLayout>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
